import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const stPageIntroStandard = () => {

    const animation = document.querySelectorAll('[data-animation="page-intro-standard"]');
    if(!animation) return;

    animation.forEach(element => {
        const span = element.querySelector('span.h1.u-text-outline');
        const title = element.querySelector('h1');
        const button = element.querySelector('.c-button');

        const tl = gsap.timeline({
            defaults: {
                duration: 2,
                ease: 'power4.out',
                delay: 0.25
            }
        });

        tl
        .to([span, title, button], {
            y: 0,
            autoAlpha: 1,
            stagger: 0.15
        });
    })

}

export { stPageIntroStandard }